export const CheckboxOptionKeys = {
  HeatingSource: {
    LongDistanceHeating: 'long_distance_heating',
    Gas: 'gas',
    HeatingOil: 'heating_oil',
    Pellets: 'pellets',
    Solar: 'solar',
    HeatPump: 'heat_pump',
    Other: 'other'
  }
};

const translationKeyMapping = [
  {
    optionKey: CheckboxOptionKeys.HeatingSource.LongDistanceHeating,
    translationKey: 'checkboxOptionHeatingSourceLongDistanceHeating',
    index: 0
  },
  {
    optionKey: CheckboxOptionKeys.HeatingSource.Gas,
    translationKey: 'checkboxOptionHeatingSourceGas',
    index: 1
  },
  {
    optionKey: CheckboxOptionKeys.HeatingSource.HeatingOil,
    translationKey: 'checkboxOptionHeatingSourceHeatingOil',
    index: 2
  },
  {
    optionKey: CheckboxOptionKeys.HeatingSource.Pellets,
    translationKey: 'checkboxOptionHeatingSourcePellets',
    index: 3
  },
  {
    optionKey: CheckboxOptionKeys.HeatingSource.Solar,
    translationKey: 'checkboxOptionHeatingSourceSolar',
    index: 4
  },
  {
    optionKey: CheckboxOptionKeys.HeatingSource.HeatPump,
    translationKey: 'checkboxOptionHeatingSourceHeatPump',
    index: 5
  },
  {
    optionKey: CheckboxOptionKeys.HeatingSource.Other,
    translationKey: 'checkboxOptionHeatingSourceOther',
    index: 6
  }
];

export function translationKeyForCheckboxOption(radioOption: string) {
  var entry = translationKeyMapping.find((item) => item.optionKey === radioOption);
  if (entry) {
    return entry.translationKey;
  }
  console.warn('Translation Key Not set for radio option ' + radioOption + '!');
  return '';
}

export function sortSelectedOptions(options: string[]) {
  return options.sort((aKey, bKey) => {
    var entryA = translationKeyMapping.find((item) => item.optionKey === aKey);
    var entryB = translationKeyMapping.find((item) => item.optionKey === bKey);
    if (entryA && entryB) {
      return entryA?.index - entryB?.index;
    } else {
      return 0;
    }
  });
}
